export enum UsersRoutesEnum {
  LIST = '',
  CREATE = 'create',
  EDIT = 'edit/:id',
}

export const USER_ID_PARAMETER: string = 'id';
